module.exports = __webpack_public_path__ + "img/racecourse-vaal-turf-classic-2600.b38609df.svg";